import { useEffect, useState } from "react";
import { trackGAEvent, trackMetaEvent } from "./analytics";
import logo from "../assets/img/boxs_logo_new.png";
import logoWhite from "../assets/img/boxs_logo_new_white.png";
import thirdSectionImg1 from "../assets/img/image_1.jpg";
import thirdSectionImg2 from "../assets/img/image_2.jpg";
import thirdSectionImg3 from "../assets/img/image_3.jpg";
import featureImg2 from "../assets/img/feature_img_2.png";
import featureImg3 from "../assets/img/feature_img_3.png";
import video from "../assets/video/hero_video.mp4";
import facebookImg from "../assets/img/facebook.svg";
import instagramImg from "../assets/img/instagram.svg";
import linkedinImg from "../assets/img/linkedin.svg";
import youtubeImg from "../assets/img/youtube.svg";
import phoneImg from "../assets/img/phone.svg";
import mailImg from "../assets/img/mail.svg";
import locationImg from "../assets/img/location.svg";
import tickImg from "../assets/img/tick.svg";
import xmarkImg from "../assets/img/xmark.svg";
import plusImg from "../assets/img/plus.svg";
import minusImg from "../assets/img/minus.svg";

import {
  AISectionImage,
  BusinessEasySectionHeading1,
  BusinessEasySectionHeading2,
  Column,
  FaqToggleBody,
  FaqToggleContainer,
  FaqToggleHeader,
  FaqToggleRow,
  FeatureImg,
  FooterContainer,
  FooterIcon,
  FooterLeftContainer,
  FooterMiddleContainer,
  FooterRightContainer,
  Frame,
  FrameText,
  Header,
  HeroSectionHeading1,
  HeroSectionHeading2,
  HeroSectionVideo,
  Icon,
  KnowMoreButton,
  NavbarBrand,
  NavbarBrandImg,
  PlusIcon,
  RegisterButton,
  Section,
  TableContainer,
  TableRow,
  Tag,
  TechBox,
  WhiteBtn,
} from "./style";
import { useNavigate } from "react-router-dom";

const LandingPage1 = () => {
  const navigate = useNavigate();
  const [currentFaq, setCurrentFaq] = useState("");
  const problemText = "Cutlist issues?"

  const toggleFaq = (id) => {
    return currentFaq === id ? setCurrentFaq("-1") : setCurrentFaq(id);
  };

  return (
    <div id="home_page">
      {/* HEADER SECTION */}
      <Header className="app-header">
        <NavbarBrand>
          <NavbarBrandImg src={logoWhite} alt="logo" />
        </NavbarBrand>
        <div className="d-flex justify-content-between align-items-center">
          <a
            href="/login_with_otp"
            className="m-0 fs-6 text-decoration-none text-white pointer"
          >
            Login
          </a>
        </div>
      </Header>

      {/* HERO SECTION */}
      <HeroSectionVideo autoPlay loop muted playsInline>
        <source src={video} />
      </HeroSectionVideo>
      <div className="home-content text-white">
        <div className="hero-wrapper d-flex flex-column">
          <div className="hero-message">
            <HeroSectionHeading1 className="text-center">
              {problemText}
            </HeroSectionHeading1>
            <HeroSectionHeading2>
              Build using <span className="modules">modules</span>
            </HeroSectionHeading2>
          </div>
          <div className="hero-details">
            <div className="product">
              <div className="l1">
                Introducing <i>Boxs</i>
              </div>
              <div className="l2 fw-bold">for</div>
              <div className="l3">Architects & Interior Designers</div>
            </div>
            <div className="hero-points">
              <ul>
                <li>
                  <div className="main">No carpenter dependency</div>
                  <div className="sub">Build yourself in just minutes</div>
                </li>
                <li>
                  <div className="main">Complete projects on time</div>
                  <div className="sub">
                    ZERO missing/wrong panels and delays
                  </div>
                </li>
                <li>
                  <div className="main">Assured margins</div>
                  <div className="sub">Upfront costing. Zero escalations.</div>
                </li>
              </ul>
            </div>
            <div className="cta py-2 d-flex my-2 align-items-center justify-content-center">
              <a
                href="https://wa.me/7305972920?text=Tell%20me%20more%20about%20Boxs."
                className="btn btn-primary primary"
                target="_blank"
                onClick={() => {
                  trackGAEvent("l1_try_now");
                  trackMetaEvent("landingCTA");
                }}
              >
                Try now
              </a>
            </div>
          </div>
        </div>

        <div className="benefits p-4 pb-1">
          <div className="text-white pb-2 text-center fs-4 fw-bold">
            It's like{" "}
            <span style={{ color: "#1b8eed", fontStyle: "italic" }}>
              Amazon-for-Modular
            </span>
          </div>
          <div className="text-center mb-3 fs-6" style={{ color: "#CCC" }}>
            Shipping to TamilNadu & Karnataka
          </div>
          <div className="list row text-center">
            <div className="item col-md-4 shadow p-4 mb-3 border">
              <div></div>
              <h4 className="">100% Customizable</h4>
              <p>
                Size, Colors, Pattern, Profile - name anything - it can be built
                using Boxs.
              </p>
            </div>
            <div className="item col-md-4 shadow p-4 mb-3 border">
              <h4 className="">No build expertise required</h4>
              <p>Your designer can order it in no time</p>
            </div>
            <div className="item col-md-4 shadow p-4 mb-3 border">
              <h4 className="">Easy to install</h4>
              <p>
                With module and room level packing, any carpenter team can
                install it like a breeze.
              </p>
            </div>
          </div>
          <div className="cta py-2 d-flex align-items-center justify-content-center">
            <a
              href="https://wa.me/7305972920?text=I%20want%20to%20know%20more%20about%20Boxs."
              className="btn btn-primary primary"
              target="_blank"
              onClick={() => {
                trackGAEvent("l1_schedule_demo");
                trackMetaEvent("landingCTA");
              }}
            >
              Schedule a demo
            </a>
          </div>
        </div>

        {/* FOOTER */}
        <Section bgcolor="#1d1d1f" className="fs-6 text-white text-center">
          <FooterContainer>
            <Section className="py-4">
              <img
                className="logo object-fit-contain"
                src={logoWhite}
                alt="logo"
              />
            </Section>
            <Section>
              <div className="fs-6 mb-2 pb-4 d-inline-flex align-items-center">
                <span className="me-3 d-inline-flex align-items-center">
                  <span className="fa-solid fa-phone me-2 fs-2"></span>
                  <a
                    href="https://wa.me/7305972920"
                    className="text-white text-decoration-none"
                  >
                    7305972920
                  </a>
                </span>
                <span className="d-inline-flex align-items-center">
                  <span className="fa fa-regular fa-envelope me-2 fs-2"></span>
                  <a
                    href="mailto:orders@boxs.in"
                    className="fs-6 text-white text-decoration-none"
                  >
                    orders@boxs.in
                  </a>
                </span>
              </div>
              <hr className="m-0 text-white"></hr>
              <div className="fs-6 text-white py-4 d-inline-flex align-items-center">
                <span className="fa fa-location-dot me-2 fs-2"></span>
                <a
                  href="https://maps.app.goo.gl/83kvAwcZzDyNdvReA"
                  className="text-white text-decoration-none"
                >
                  Made in Chennai, India {"("}
                  <span className="text-decoration-underline">location</span>
                  {")"}
                </a>
              </div>
            </Section>
          </FooterContainer>
        </Section>
      </div>
    </div>
  );
};

export default LandingPage1;
